import { GET, POST } from "@/services/request";
import * as APIs from '@/services/APIs';

/**
 * 服务列表(搜索)
 */
export const fetchServiceRecord = async (params) => {
    const res = await GET(APIs.API_SERVICE_QUERYLIST, { params });

    return res.data.data ?? {};
};

/**
 * 操作日志
 */
export const fetchLogList = async (params) => {
    const res = await GET(APIs.API_SERVICE_LOGLIST, { params });

    return res.data.data ?? {};
};